<template>
  <div class="info-block">
    <div class="info-block-title">
      <TitleComp1 :title="title" />
      <slot name="titleRight"></slot>
    </div>
    <div class="info-block-content">
      <border-comp3 v-if="border">
        <slot name="content"></slot>
      </border-comp3>
      <div v-else style="height: 100%">
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import BorderComp3 from '@/components/border-comp3';
import TitleComp1 from '@/components/title-comp1';

export default {
  name: 'InfoBlock',
  components: {
    BorderComp3,
    TitleComp1
  },
  props: {
    title: [String, Array],
    border: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style lang="scss" scoped>
.info-block {
  height: 100%;
  margin-bottom: 15px;
  .info-block-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
  }
  .info-block-content {
    height: calc(100% - 70px);
  }
}
</style>
